import { Capacitor } from '@capacitor/core';
export const getReferralProfile = ({ onNextAction /** @type {string?} */, onNextData /** @type {string?} */ }) => {
  return {
    p: Capacitor.getPlatform(),
    referrer: Capacitor.isNativePlatform() ? `capacitor://${process.env.CAPACITOR_HOST_NAME}` : process.env.PUBLIC_URL,
    nextData: onNextData,
    nextAction: onNextAction
  };
};
